
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6 4h20v8l-2-2V6H8v20h16v-4l2-2v8H6V4zm16.406 7l4.313 4.281.688.719-.688.719L22.406 21 21 19.594 23.563 17h-9.656v-2h9.656L21 12.406z"}})])
          )
        }
      }
    